export default "__VITE_ASSET__DeNqla13__"